import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { RAW_DATE_FORMAT } from '@/common/constants';
import { API_URL, IContributionSegmentResponseDto } from '@/dtos';

import { Recipient, Segment } from '../types';
import formatDataToPayload from '../utils/formatDataToPayload';

interface Props {
  recipients: Recipient[];
  segment: Segment;
}

const useCreateManualContributionQuery = (isCreatingFromTemplate?: boolean) => {
  const { mutateAsync, isLoading } = useMutation((props: Props) => {
    return api.post<IContributionSegmentResponseDto>(
      API_URL.MANUAL_CONTRIBUTION,
      formatDataToPayload(props.recipients, props.segment, isCreatingFromTemplate),
      {
        params: {
          contribution_date: dayjs(props?.segment?.contributionDate).format(RAW_DATE_FORMAT),
        },
      }
    );
  });

  const createManualContribution = useCallback(
    async (props: Props) => {
      const response = await mutateAsync(props);
      return response;
    },
    [mutateAsync]
  );

  return {
    isLoading,
    createManualContribution,
  };
};

export default useCreateManualContributionQuery;
